import { Component } from '@angular/core';

@Component({
  selector: 'app-public-layout-monitor',
  templateUrl: './public-layout-monitor.component.html',
  styleUrls: ['./public-layout-monitor.component.scss']
})
export class PublicLayoutMonitorComponent {

}
